module.exports = __webpack_public_path__ + "img/wav.07ca5d77.png";